import type { RecruitingInvitation } from '../schema'

/** Both names are optional on a recruiting link, so either may be missing. */
export function getInvitationName(
  invitation: Pick<RecruitingInvitation, 'firstName' | 'lastName'>
): string {
  return [invitation.firstName, invitation.lastName].filter(Boolean).join(' ')
}
